export function includesAll(hostArray: number[], searchArray: number[]): boolean {
  return !searchArray.some(item => !hostArray.includes(item));
}
